import BlogButtonGenerator from '@/features/blog-button';

function BlogButtonPage() {
  return <BlogButtonGenerator />;
}

export default BlogButtonPage;

